export const SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH = "/customer/subscription";
